import { LockOutlined, UserOutlined } from '@ant-design/icons'
import { Button, Card, Checkbox, Form, Input, Typography, message } from 'antd'
import { type FC } from 'react'
import { useMutation } from '@tanstack/react-query'
import { useDispatch } from 'react-redux'
import { Link, Navigate, useNavigate } from 'react-router-dom'
import { apiLogin } from '~/api/adminApi'
import RadupIcon from '~/assets/images/icon.png'
import { setAuthToken } from '~/store/auth/slice'
import { AUTH_TOKEN } from '~/utils/constants'
import './styles.scss'
import { showErrors } from '~/utils/helpers'
import FormCard from './FormCard'

const { Title } = Typography

interface SignInProps {
  isAuthenticated: boolean
}

const SignIn: FC<SignInProps> = ({ isAuthenticated }) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const loginMutation = useMutation({
    mutationFn: apiLogin,
    onSuccess: (data) => {
      if (data.require_password_change === true) {
        message.warning('Please provide a new password for your account to continue')
        navigate('/change-password?token=' + data.token)
        return
      }

      if (!data.is_disabled) {
        localStorage.setItem(AUTH_TOKEN, data.token)
        dispatch(setAuthToken(data.token))
      }
    },
    onError: showErrors
  })

  if (isAuthenticated) {
    return <Navigate to={'auto-select'} />
  }

  if (loginMutation.data?.is_disabled === true) {
    return <div className="signin-form">
      <img src={RadupIcon} width="120" alt="" />
      <Card style={{ textAlign: 'center' }}>
        <Typography.Paragraph>
          This account has been disabled.
        </Typography.Paragraph>
        <Typography.Text>
          In case of any problems, kindly contact <br />
          <a href='mailto:claudia@radup.com'>claudia@radup.com</a>.
        </Typography.Text>
      </Card>
    </div>
  }

  return (
    <div className="signin-form">
      <img src={RadupIcon} width="120" alt="" />
      <FormCard>
        <Form
          name="normal_login"
          className="login-form"
          initialValues={{ remember: true }}
          onFinish={loginMutation.mutate}
        >
          <Title level={2}>Sign In</Title>
          <Form.Item
            name="email"
            rules={[{ required: true, message: 'Please input your Username!' }]}
          >
            <Input prefix={<UserOutlined className="site-form-item-icon" />} placeholder="Email" />
          </Form.Item>
          <Form.Item
            name="password"
            extra={[
              <Link key='forgot' to='/forgot-password' >Forgot my password</Link>
            ]}
            rules={[{ required: true, message: 'Please input your Password!' }]}
          >
            <Input
              prefix={<LockOutlined className="site-form-item-icon" />}
              type="password"
              placeholder="Password"
              style={{ marginBottom: 10 }}
            />
          </Form.Item>
          <Form.Item>
            <Form.Item name="remember" valuePropName="checked" noStyle>
              <Checkbox>Remember me</Checkbox>
            </Form.Item>
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" className="login-form-button">
              Log in
            </Button>
          </Form.Item>
        </Form>
      </FormCard>
    </div>
  )
}

export default SignIn
